// Monitora e registra métricas de Web Vitals
import { getLCP, getFID, getCLS } from "https://unpkg.com/web-vitals@3?module";

function sendToAnalytics({ name, delta, value, id }) {
  console.log(`${name}: ${value}`);

  // Envie para seu sistema de análise ou para o dataLayer do GTM
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "web-vitals",
    webVitalsMeasurement: {
      name: name,
      value: Math.round(name === "CLS" ? delta * 1000 : delta),
      rating: value < getThreshold(name) ? "good" : "poor",
      delta: Math.round(delta),
      id: id,
    },
  });
}

function getThreshold(metric) {
  switch (metric) {
    case "LCP":
      return 2500;
    case "FID":
      return 100;
    case "CLS":
      return 0.1;
    default:
      return 0;
  }
}

getLCP(sendToAnalytics);
getFID(sendToAnalytics);
getCLS(sendToAnalytics);
